import { render, staticRenderFns } from "./SearchableDocumentsListCustom.vue?vue&type=template&id=4747f3e4"
import script from "./SearchableDocumentsListCustom.vue?vue&type=script&lang=ts"
export * from "./SearchableDocumentsListCustom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4747f3e4')) {
      api.createRecord('4747f3e4', component.options)
    } else {
      api.reload('4747f3e4', component.options)
    }
    module.hot.accept("./SearchableDocumentsListCustom.vue?vue&type=template&id=4747f3e4", function () {
      api.rerender('4747f3e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/SearchableDocumentsListCustom.vue"
export default component.exports